import { isBoolean, isArray, isDefined } from '@grandvisionhq/utils';

const getConfigurationSpecificationItems = (specificationConfiguration, productSpecificationItems, getLabel)=>specificationConfiguration.map((configItem)=>{
        const specItem = productSpecificationItems.find((spec)=>spec.specificationAttribute === configItem.attribute
        );
        if (!specItem) {
            return;
        }
        let value = specItem.value;
        if (isBoolean(value)) {
            value = value ? getLabel('common.yes') : getLabel('common.no');
        }
        if (isArray(value)) {
            value = value.join(', ');
        }
        if (configItem.labelPrefix) {
            value = getLabel(`${configItem.labelPrefix}${specItem.value}`);
        }
        return {
            key: configItem.attribute,
            value,
            label: getLabel(configItem.labelKey)
        };
    }).filter(isDefined)
;

export { getConfigurationSpecificationItems };
//# sourceMappingURL=get-configuration-specification-items.js.map
